import React from 'react';
import history from 'dashboard/history';
import { Provider } from 'react-redux';
import { Playground, store } from 'graphql-playground-react';
import EmptyState from 'components/EmptyState/EmptyState.react';
import styles from './GraphQLConsole.scss';

const codeTheme = {
  // property: 'green',
  // comment: string
  // punctuation: string
  // keyword: string
  // def: string
  // qualifier: string
  // attribute: string
  // number: string
  // string: string
  // builtin: string
  // string2: string
  // variable: string
  // meta: string
  // atom: string
  // ws: string
  // selection: string
  // cursorColor: string
  editorBackground: '#333c48',
  resultBackground: '#212932',
  leftDrawerBackground: '#151a1f',
};

const GraphQLConsole = ({ currentApp }) => {
  const goTo = `/products/apps/${currentApp.slug}/runtime/version`;
  const { applicationId, graphQLServerURL, masterKey } = currentApp;
  let content;
  if (!graphQLServerURL) {
    content = (
      <div className={styles.empty}>
        <EmptyState
          title="GraphQL API Console"
          descriptionWithHTML='Upgrade to <strong>Parse Server v3.5.0</strong> or a later one to use the <strong>GraphQL</strong> &amp; <strong>GraphQL API Console</strong>.'
          cta='Change Parse Server Version'
          action={() => history.push(goTo)} />
      </div>
    );
  } else {
    const headers = {
      'X-Parse-Application-Id': applicationId,
      'X-Parse-Master-Key': masterKey,
    };
    content = (
      <Provider store={store}>
        <Playground endpoint={graphQLServerURL} headers={headers} codeTheme={codeTheme} />
      </Provider>
    );
  }

  return (
    <div className={styles.content}>
      {content}
    </div>
  );
}

export default GraphQLConsole;
